"use client";
import React from "react";
import Footer from "../components/Footer";
import FirstSection from "../components/common/FirstSection";
import aboutIcon from '../assets/about/icon.png';
import background from '../assets/random-graphic.png';
import HeadingWithChips from "../components/common/HeadingWithChips";
import PictureWithText from "../components/common/PictureWithText";
import pictureWithTextBackground from '../assets/trust-section/trust.png';
import OurVision from "../components/about/OurVision";

const AboutUs: React.FC = () => {
  return (
        <main>
        <FirstSection 
        icon={aboutIcon}
        iconAlt="Suite icon"
        backgroundImage={background}
        title="Money should <br/>
            work for you,<br/>
            not against you"
        description={
            <>
                Managing your finances should be <br/>
                simple and empowering. That’s why <br/>
                we’re building a better way to pay.
            </>
        }
        buttonText="CONTACT US"
        buttonVariant="lightPurple"
        buttonHref="/contact"
        leftColumnSx={{
            backgroundColor: "beige.200"
        }}
        heading="about EPAYR"
        />
        <HeadingWithChips 
          headingPrefix="WHO "
          headingHighlight="WE"
          headingSuffix=" ARE"
          subheading=''
          discussionText={["WE'RE A TEAM OF ", " PROFESSIONALS WITH DEEP BANKING EXPERTISE. FRUSTRATED BY OUTDATED SYSTEMS AND HIDDEN FEES, WE CREATED EPAYR TO ", 
            "A SMARTER, MORE TRANSPARENT ALTERNATIVE. OUR SECURE, USER-FRIENDLY", 
            "IS BUILT ON CORE BANKING PRINCIPLES, ENSURING RELIABILITY AND TRUST"]}
          chips = {[
            { text: "FINANCE", backgroundColor: "lime.100", textColor: "lightPurple.500" },
            { text: "OFFER",  backgroundColor: "beige.200",  textColor: "beige.700" },
            { text: "PLATFORM", backgroundColor: "lightPurple.200", textColor: "lightPurple.500" },
          ]}
          displayIcons={true}
        />
        <PictureWithText 
            backgroundImage={pictureWithTextBackground} 
            titleSegments={[{ text: "OUR ", color: "darkPurple.500" },
                { text: "MISSION", color: "lightPurple.500" }]} 
            description={"We’re here to simplify financial services and give you the tools to take control of your money —whether you’re an individual or a business"}        
        />
        <OurVision/>
        <HeadingWithChips 
          headingPrefix="OUR "
          headingHighlight="COMMITMENT"
          headingSuffix=""
          subheading=''
          discussionText={["AT EPAYR, WE PRIORITIZE ", ",", " AND ",
            "<br/>NO HIDDEN FEES, NO CONFUSING JARGON - JUST ", " AND ",
            " TO SUPPORT YOUR FINANCIAL JOURNEY."
          ]}
          sectionSize={{xs: 343, sm: 562}}
          chips = {[
            { text: "TRANSPARENCY", backgroundColor: "lime.100", textColor: "lime.300" },
            { text: "SECURITY", backgroundColor: "lime.100", textColor: "lime.300" },
            { text: "SIMPLICITY.", backgroundColor: "lime.100", textColor: "lime.300" },
            { text: "HONEST PRICING", backgroundColor: "lightPurple.200", textColor: "lightPurple.500" },
            { text: "CLEAR TOOLS",  backgroundColor: "beige.200",  textColor: "beige.700" },
            
          ]}
          displayIcons={false}
        />
        <Footer 
              buttonText="GET STARTED" 
              buttonLink="/contact?type=company"
              ctaText={{
                prefix: '',
                highlight1: 'TRUST',
                middle: " IS BUILT OVER TIME AND WE'RE HERE <br/> TO",
                highlight2: ' EARN',
                suffix: ' IT - EVERY STEP OF THE WAY'
              }}
            />
        </main>
  );
};

export default AboutUs;
